import * as R from 'ramda'
import React from 'react'
import sanityClient from '@sanity/client'
import Layout from '../components/Layout'
import TestimonialForm from '../components/TestimonialForm'

const client = sanityClient({
  projectId: process.env.GATSBY_SANITY_ID,
  dataset: process.env.GATSBY_SANITY_DATASET,
  token: process.env.GATSBY_SANITY_TOKEN,
  useCdn: false, // `false` if you want to ensure fresh data
})

export default function Index(props) {
  return (
    <Layout>
      <TestimonialForm client={client} />
    </Layout>
  )
}
